import { useId, useState } from "react";
import { todayISO } from "../controleFormat";
import { CHARTER_THEME } from "../controleTheme";
import {
    buttonBase,
    controleContextMenuDangerButtonStyle,
    controleContextMenuStyle,
    controleModalOverlayStyle,
    controleModalStyle,
    modalCloseButtonStyle,
} from "../styles/layoutStyles";
import { SearchableEhpadField } from "./SearchableEhpadField";
import ModalBackdrop from "../../../../components/ModalBackdrop";

// Menu et fenêtres de gestion des dossiers de lot, identiques dans les écrans Contrôle et Contrôle Bis.

export function DossierContextMenu({ menu, onClose, onDelete }) {
    if (!menu) return null;
    return (
        <div
            role="menu"
            style={{
                ...controleContextMenuStyle,
                left: menu.x,
                top: menu.y,
            }}
            onClick={event => event.stopPropagation()}
            onKeyDown={event => {
                event.stopPropagation();
                if (event.key === "Escape") onClose();
            }}
            tabIndex={-1}
            onContextMenu={event => event.preventDefault()}
        >
            <button
                type="button"
                role="menuitem"
                onClick={() => onDelete(menu.dossier)}
                style={controleContextMenuDangerButtonStyle}
            >
                Supprimer
            </button>
        </div>
    );
}

export function DeleteDossierModal({ candidate, saving, onCancel, onConfirm }) {
    if (!candidate) return null;
    return (
        <div style={controleModalOverlayStyle}>
            <ModalBackdrop onClose={() => onCancel()} />
            <div role="alertdialog" aria-modal="true" aria-labelledby="delete-dossier-title" style={{ ...controleModalStyle, position: "relative", zIndex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "flex-start" }}>
                    <div>
                        <h2 id="delete-dossier-title" style={{ margin: 0, color: "#0f172a", fontSize: "18px", fontWeight: 950 }}>Supprimer le dossier de lot</h2>
                        <p style={{ margin: "8px 0 0", color: "#475569", fontSize: "13px", lineHeight: 1.45 }}>
                            Confirmer la suppression du dossier {candidate.numeroLot} de {candidate.ehpadNom} ?
                        </p>
                    </div>
                    <button type="button" onClick={() => onCancel()} style={modalCloseButtonStyle}>×</button>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                    <button type="button" onClick={() => onCancel()} style={{ ...buttonBase, background: "white", color: "#334155" }}>Annuler</button>
                    <button type="button" onClick={onConfirm} disabled={saving} style={{ ...buttonBase, background: "#dc2626", borderColor: "#dc2626", color: "white", fontWeight: 900 }}>
                        {saving ? "Suppression..." : "Supprimer"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export function PrintReportConfirmModal({ open, remainingPatientCount, onCancel, onConfirm }) {
    if (!open) return null;
    return (
        <div style={controleModalOverlayStyle}>
            <ModalBackdrop onClose={() => onCancel()} />
            <div role="alertdialog" aria-modal="true" aria-labelledby="print-report-title" style={{ ...controleModalStyle, position: "relative", zIndex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "flex-start" }}>
                    <div>
                        <h2 id="print-report-title" style={{ margin: 0, color: "#0f172a", fontSize: "18px", fontWeight: 950 }}>Imprimer le rapport maintenant ?</h2>
                        <p style={{ margin: "8px 0 0", color: "#475569", fontSize: "13px", lineHeight: 1.5 }}>
                            Il reste <strong>{remainingPatientCount}</strong> patient{remainingPatientCount > 1 ? "s" : ""} à valider.
                            Êtes-vous sûr de vouloir imprimer le rapport maintenant ?
                        </p>
                    </div>
                    <button type="button" onClick={() => onCancel()} style={modalCloseButtonStyle}>×</button>
                </div>
                <div style={{
                    display: "grid",
                    gap: "8px",
                    padding: "12px",
                    borderRadius: "8px",
                    background: "#fff7ed",
                    border: "1px solid #fed7aa",
                    color: "#9a3412",
                    fontSize: "13px",
                    lineHeight: 1.45,
                }}>
                    Le rapport peut être incomplet tant que tous les contrôles patients ne sont pas validés.
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", flexWrap: "wrap" }}>
                    <button type="button" onClick={() => onCancel()} style={{ ...buttonBase, background: "white", color: "#334155" }}>
                        Annuler
                    </button>
                    <button type="button" onClick={onConfirm} style={{ ...buttonBase, background: "#0f172a", borderColor: "#0f172a", color: "white", fontWeight: 900 }}>
                        Imprimer quand même
                    </button>
                </div>
            </div>
        </div>
    );
}

export function CreateDossierModal({ ehpads, initialEhpadId, saving, onCancel, onCreate }) {
    const { inputStyle } = CHARTER_THEME;
    const [ehpadId, setEhpadId] = useState(initialEhpadId || "");
    const [dateProduction, setDateProduction] = useState(todayISO());
    const ehpadFieldId = useId();
    const dateFieldId = useId();
    const ehpad = ehpads.find(e => String(e.id) === String(ehpadId));
    return (
        <div style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.42)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 400,
            padding: "18px",
        }}>
            <div style={{ width: "100%", maxWidth: "420px", background: "white", borderRadius: "8px", border: "1px solid #e2e8f0", boxShadow: "0 20px 45px rgba(15, 23, 42, 0.22)" }}>
                <div style={{ padding: "16px 18px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
                    <h2 style={{ margin: 0, fontSize: "17px", color: "#0f172a" }}>Création fiche de contrôle</h2>
                    <button type="button" onClick={() => onCancel()} style={{ ...buttonBase, padding: "5px 9px", background: "white", color: "#475569" }}>
                        Fermer
                    </button>
                </div>
                <div style={{ padding: "18px" }}>
                    <label htmlFor={ehpadFieldId} style={{ display: "block", fontSize: "12px", color: "#64748b", marginBottom: "5px", fontWeight: 700 }}>EHPAD</label>
                    <SearchableEhpadField
                        id={ehpadFieldId}
                        ehpads={ehpads}
                        value={ehpadId}
                        onChange={setEhpadId}
                        placeholder="Rechercher un EHPAD"
                        style={{ marginBottom: "12px" }}
                    />
                    <label htmlFor={dateFieldId} style={{ display: "block", fontSize: "12px", color: "#64748b", marginBottom: "5px", fontWeight: 700 }}>Date de production</label>
                    <input id={dateFieldId} style={{ ...inputStyle, width: "100%", marginBottom: "6px" }} type="date" value={dateProduction} onChange={e => setDateProduction(e.target.value)} />
                    {ehpad && (
                        <div style={{ color: "#64748b", fontSize: "12px", marginBottom: "16px" }}>
                            La fiche sera rattachée à {ehpad.nom}.
                        </div>
                    )}
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                        <button type="button" onClick={() => onCancel()} style={{ ...buttonBase, background: "white", color: "#334155" }}>
                            Annuler
                        </button>
                        <button type="button" onClick={() => onCreate(ehpadId, dateProduction)} disabled={saving || !ehpadId || !dateProduction} style={{ ...buttonBase, background: "#2563eb", borderColor: "#2563eb", color: "white", fontWeight: 700 }}>
                            Créer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
